<script>
    import { blur } from 'svelte/transition';
    import API from '../api';
    import OPTS from "../options";
    import Pagination from "./Pagination.svelte";

    export let id;
    export let text = 'ND';
    export let tags = [];
    export let has_children = false;
    export let children = null;
    export let active = false;
    export let expanded = false;
    let loading = false;

    $: node_class = expanded ? "list-group-item tree-item-expanded" : "list-group-item d-flex align-items-center";

    async function toggle() {
        if (children && children.total > 0) {
            expanded = !expanded;
        } else {
            await loader( async () => {
                children = await API.childrens(id, 1);
                expanded = true;
            });
        }
    }

    async function goToPage(e) {
        await loader(async () => children = await API.childrens(id, e.detail.page) );
    }

    function openLink() {
        window.top.location.href = `${OPTS.base_url}archivio/storico/${id}`;
    }

    async function loader(action) {
        loading = true;
        await action();
        loading = false;
    }
</script>

<li class={node_class} class:tree-item-active={active || (OPTS.mode === 'full' && id === OPTS.node_id)}>
    {#if loading}
        <div class="spinner-border spinner-border-sm"  role="status">
            <span class="sr-only">Loading...</span>
        </div>
    {:else if has_children}
        <a href="#" on:click|preventDefault={toggle} class="oi tree-item-icon oi-folder" title="icon name" aria-hidden="true"></a>
    {:else}
        <span class="oi tree-item-icon oi-file" title="icon name" aria-hidden="true"></span>
    {/if}
    <a href="#" on:click|preventDefault={openLink}>{@html text}</a>

    <div class="ml-auto tree-tag-container">
        {#each tags as tag (tag)}
            <span class="badge badge-primary badge-pill" style="margin-left: 5px;">{tag}</span>
        {/each}
    </div>

    {#if expanded}
        <div in:blur class="card tree-child-container">
            <ul class="list-group list-group-flush">
                {#each children.elements as child (child.id)}
                    <svelte:self {...child}/>
                {/each}
            </ul>

            {#if children.num_pages > 1}
                <div class="card-footer">
                    <Pagination on:page-change={goToPage} current={children.current_page} total={children.num_pages} />
                </div>
            {/if}
        </div>
    {/if}
</li>

<style>
    .card-footer {
        background-color: #EF4136;
    }
    .tree-tag-container {
       display: inline;
    }

    .tree-item-icon {
        margin-right: 10px;
    }

    .tree-item-expanded > .tree-tag-container {
        float: right;
        margin-right: 1.25rem;
    }

    .list-group-item > a {
        text-decoration: none;
        color: black;
    }

    .tree-child-container {
        border-left: 1px solid rgba(0,0,0,.125) !important;
        border-right: none !important;
        border-top: none !important;
        border-bottom: none !important;
    }

    .tree-tag-container .badge {
        background-color: #EF4136;
    }

    .tree-item-active {
        color: #004085;
        background-color: #b8daff;
    }

    .tree-item-expanded {
        padding-right: unset;
    }
</style>